export const TEST_ID = 'formulationReviewContent';

export const LOADING_SKELETON_KEYS = ['skeleton-summary', 'skeleton-label', 'skeleton-sds'];
